// extracted by mini-css-extract-plugin
module.exports = {"landing":"LandingPage_landing__1mujs","boton":"LandingPage_boton__mAV63","mensaje":"LandingPage_mensaje__8pv23"};